/**
 * Fast Track payment calls for the secure link flow (/link/loan-fastrack-payment): loan-service's @SecureLinkEndpoint
 * endpoints, authorized by the secure link session (Authorization: Bearer). Never sends a Fast Track or loan id: the
 * server takes the Fast Track from the session.
 */
const BASE = '/api/v1/loan/secure-link/loan-fastrack';

export type SecureLinkRequest = <T>(path: string, init?: RequestInit) => Promise<T>;

/** What the page shows (nportal LoanFastrackSecureLinkData), and where the borrower is in the flow. */
export interface LoanFastrackLinkData {
  dealName?: string;
  totalFee?: number;
  fastTrackFee?: number;
  insuranceFee?: number;
  insuranceReviewFee?: number;
  titleSearchFee?: number;
  rushedAppraisalFee?: number;
  feeComponents?: string;
  feeCalcError?: string;
  /** The CardKnox page to pay on; carries the cardholder's name once it is passed. */
  cardKnoxURL?: string;
  signed: boolean;
  paid: boolean;
}

export class SecureLinkLoanFastrackService {
  constructor(private readonly request: SecureLinkRequest) {}

  getData(cardHolderName?: string) {
    const query = cardHolderName ? `?cardHolderName=${encodeURIComponent(cardHolderName)}` : '';
    return this.request<LoanFastrackLinkData>(`${BASE}/data${query}`);
  }

  sign(data: { cardHolderName: string; signature: string; userAgent: string }) {
    return this.request(`${BASE}/sign`, {
      method: 'POST',
      body: JSON.stringify({
        cardHolderName: data.cardHolderName,
        signature: data.signature,
        userAgent: data.userAgent,
      }),
    });
  }
}
